export default __webpack_public_path__ + "static/media/ColorShiftsCancelled.50292ec7.svg";